import React from 'react';

import { Icon } from '@simplybusiness/mobius-core';

const circleStyles = {
  shared: {
    display: 'block',
    width: 60,
    height: 60,
    fontSize: 30,
    lineHeight: '60px',
    fontColor: '#fff',
    textAlign: 'center',
    borderRadius: '50%',
    margin: '0 auto',
  },
  green: {
    backgroundColor: '#577a30',
  },
  magenta: {
    backgroundColor: '#de2874',
  },
};

const CircleIcon = ({ icon, variant }) => {
  const styles = {
    ...circleStyles.shared,
    ...circleStyles[variant],
  };

  return (
    <div style={styles}>
      <Icon color="white" icon={icon} />
    </div>
  );
};

export default CircleIcon;
